import { useEffect, useState } from 'react'
import { isMobile } from 'react-device-detect'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { postPromotion } from '../../api/coupons'
import { postMypayAcc } from '../../api/login'
import { getReviewableProduct, putGuestConfirm, putUserConfirm } from '../../api/orderHistory'
import '../../css/OrderDetail.css'
import { AFWebLinkType, handlePostMessage, RNPostMessage } from '../../js/postMessage'
import { getParsedSessionStorageItem, plusComma } from '../../js/script'
import { OrderProduct } from '../../pages/myshopping/OrderDetail'
import MyChannerlTalk from '../myshopping/MyChannerTalk'
import { useCommonContext } from '../provider/CommonProvider'
import { getMyReview } from '../../api/product'
import { useAppContext } from '../provider/AppProvider'

//결제완료 or 배송준비중
export function OrderComplete({ el }: any) {
  const [lastNumber, setLastNumber] = useState<number>(0)
  const [optionNo, setOptionNo] = useState<number>(0)
  const [stateArray, setStateArray] = useState<string[]>([])
  const navigate = useNavigate()
  const location = useLocation()

  const { isAppView } = useAppContext()

  const queryParams = new URLSearchParams(location.search)
  const guestToken = isAppView ? queryParams.get('guestToken') : location.state?.guestToken

  useEffect(() => {
    if (el?.orderOptionsGroupByPartner[0]) {
      const orderOptions = el.orderOptionsGroupByPartner[0].orderOptionsGroupByDelivery[0]?.orderOptions || []

      // 상태 변수 초기화
      const array: any[] = []
      const statusArray: any[] = []

      orderOptions.forEach((element: any) => {
        // 클레임 상태 체크
        if (
          element.claimStatusType === 'CANCEL_NO_REFUND' ||
          element.claimStatusType === 'CANCEL_REQUEST' ||
          element.claimStatusType === 'CANCEL_DONE' ||
          element.claimStatusType === 'CANCEL_PROC_REQUEST_REFUND' ||
          element.claimStatusType === 'CANCEL_PROC_WAITING_REFUND'
        ) {
          array.push(element)
        }
        // 상태 배열에 주문 상태 추가
        statusArray.push(element.orderStatusType)
      })

      // 상태 업데이트
      setOptionNo(orderOptions.length)
      setLastNumber(array.length)
      setStateArray(statusArray)
    }
  }, [el])
  return (
    <OrderProduct>
      <div className='order_product_tit '>
        <div>
          <p>상품 정보</p>
          <em>주문번호 {el?.orderNo}</em>
        </div>
        <span
          style={{
            background: optionNo === lastNumber ? 'var(--colGray2)' : 'var(--colLightBlue)',
            color: optionNo === lastNumber ? 'var(--colGray7)' : 'var(--colPointBlue)',
          }}
        >
          {stateArray.includes('DELIVERY_PREPARE')
            ? '배송준비중'
            : el?.orderOptionsGroupByPartner[0]?.orderOptionsGroupByDelivery[0]?.orderOptions[0]?.claimStatusType ===
                'CANCEL_REQUEST' && optionNo === lastNumber
            ? '취소신청'
            : '주문완료'}
        </span>
      </div>
      {el?.orderOptionsGroupByPartner[0]?.orderOptionsGroupByDelivery[0]?.orderOptions.map((el: any, idx: number) => {
        return <OrderDetailListItem el={el} key={el.optionNo} idx={idx} lastNumber={lastNumber}></OrderDetailListItem>
      })}

      {lastNumber === optionNo ? null : !stateArray.includes('DELIVERY_PREPARE') ? (
        <div
          className='order_btn'
          onClick={() => {
            if (isAppView) {
              RNPostMessage(AFWebLinkType.moveToLink, {
                url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/ordercancel?orderNo=${el.orderNo}&guestToken=${guestToken}`,
              })
            } else {
              navigate(`/ordercancel`, {
                state: {
                  orderNo: el.orderNo,
                  guestToken: guestToken || null,
                },
              })
            }
          }}
        >
          <button type='button'>주문취소</button>
        </div>
      ) : (
        <div className='order_btn'>
          <button
            type='button'
            onClick={() => {
              const CT = new MyChannerlTalk()
              CT.boot({ pluginKey: '168ab92f-c06e-476b-a2cb-95c54ee01572' })
              CT.openChat()
              return () => {
                CT.shutdown()
              }
            }}
          >
            1:1 문의하기
          </button>
        </div>
      )}
      {!el?.orderOptionsGroupByPartner[0]?.orderOptionsGroupByDelivery[0]?.orderOptions.includes(
        'DELIVERY_PREPARE'
      ) ? null : (
        <div className='info_txt'>
          <p>
            상품이 택배사로 전달된 경우 일부 처리는 불가할 수 있습니다.
            <br />
            상담원을 통해 문의해 주세요.
          </p>
        </div>
      )}
    </OrderProduct>
  )
}
//배송중
export function Delivery_Ing({ el }: any) {
  const [optionArray, setOptionArray] = useState()
  const [claimArray, setClaimArray] = useState<any>([])
  const [claimText, setClaimText] = useState<any>([])
  const [lastNumber, setLastNumber] = useState()
  const { hasAccessToken } = useCommonContext()
  const navigate = useNavigate()
  const location = useLocation()
  useEffect(() => {
    if (el) {
      const array: any = []
      const claimArray: any = []
      const text: any = []
      el?.orderOptionsGroupByPartner[0]?.orderOptionsGroupByDelivery[0]?.orderOptions?.map((el: any) => {
        if (
          el.claimStatusType === 'RETURN_REQUEST' ||
          el.claimStatusType === 'RETURN_REJECT_REQUEST' ||
          el.claimStatusType === 'RETURN_PROC_BEFORE_RECEIVE' ||
          el.claimStatusType === 'RETURN_PROC_REQUEST_REFUND' ||
          el.claimStatusType === 'RETURN_PROC_WAITING_REFUND' ||
          el.claimStatusType === 'RETURN_REJECT_REQUEST' ||
          el.claimStatusType === 'RETURN_DONE' ||
          el.claimStatusType === 'RETURN_REFUND_AMT_ADJUST_REQUESTED' ||
          el.claimStatusType === 'RETURN_NO_REFUND'
        ) {
          claimArray.push(el.orderOptionNo)
          text.push(el.claimStatusType)
        } else if (el.claimStatusType === null) {
          array.push(el.orderOptionNo)
        }
        setOptionArray(array)
        setClaimArray(claimArray)
        setClaimText(text)
      })
    }
  }, [el])

  useEffect(() => {
    if (el?.orderOptionsGroupByPartner[0]) {
      const array: any = []
      el?.orderOptionsGroupByPartner[0]?.orderOptionsGroupByDelivery[0]?.orderOptions.map((element: any) => {
        if (
          element.claimStatusType === 'RETURN_REQUEST' ||
          element.claimStatusType === 'RETURN_REJECT_REQUEST' ||
          element.claimStatusType === 'RETURN_PROC_BEFORE_RECEIVE' ||
          element.claimStatusType === 'RETURN_PROC_REQUEST_REFUND' ||
          element.claimStatusType === 'RETURN_PROC_WAITING_REFUND' ||
          element.claimStatusType === 'RETURN_REJECT_REQUEST' ||
          element.claimStatusType === 'RETURN_DONE' ||
          element.claimStatusType === 'RETURN_REFUND_AMT_ADJUST_REQUESTED' ||
          element.claimStatusType === 'RETURN_NO_REFUND'
        ) {
          array.push(element)
        }
        setLastNumber(array.length)
      })
    }
  }, [el])
  return (
    <OrderProduct>
      <div className='order_product_tit'>
        <div>
          <p>상품 정보</p>
          <em>주문번호 {el?.orderNo}</em>
        </div>
        <span
          style={{
            background:
              claimArray.length !== 0 && claimArray.length === lastNumber ? 'var(--colGray2)' : 'var(--colLightBlue)',
            color:
              claimArray.length !== 0 && claimArray.length === lastNumber ? 'var(--colGray7)' : 'var(--colPointBlue)',
          }}
        >
          {claimArray.length !== 0 && claimArray.length === lastNumber
            ? claimText.includes('RETURN_DONE')
              ? '환불완료'
              : '환불신청'
            : '배송중'}
        </span>
      </div>
      {el?.orderOptionsGroupByPartner[0]?.orderOptionsGroupByDelivery[0]?.orderOptions.map((el: any, idx: number) => {
        return <OrderDetailListItem el={el} key={el.optionNo} idx={idx} lastNumber={lastNumber}></OrderDetailListItem>
      })}
      {/* {claimArray.length === lastNumber ? (
        <div
          style={{
            padding: '16px 12px',
            borderRadius: '5px',
            background: 'var(--colGray2)',
          }}
        >
          {claimText.includes('RETURN_DONE') ? (
            <p
              style={{
                fontSize: '12px',
                lineHeight: '18px',
                color: 'var(--colGray5)',
                textAlign: 'center',
              }}
            >
              {' '}
              <b
                style={{
                  color: 'var(--colGray6)',
                  display: 'block',
                  marginBottom: '4px',
                }}
              >
                환불이 완료되었습니다.
              </b>
              카드사 결제 취소 처리는
              <br /> 영업일 기준 3~5일까지 소요될 수 있습니다.
            </p>
          ) : (
            <p
              style={{
                fontSize: '12px',
                lineHeight: '18px',
                color: 'var(--colGray5)',
                textAlign: 'center',
              }}
            >
              <b
                style={{
                  color: 'var(--colGray6)',
                  display: 'block',
                  marginBottom: '4px',
                }}
              >
                환불 신청이 완료되었습니다
              </b>
              반품 절차는 택배사 일정에 따라
              <br /> 영업일 기준 5~10일까지 소요될 수 있습니다.
            </p>
          )}
        </div>
      ) : null} */}
      {claimArray.length !== 0 && claimArray.length === lastNumber ? null : (
        <>
          <div
            className='order_btn'
            onClick={() => {
              if (!hasAccessToken) {
                navigate(`/orderrefund`, {
                  state: {
                    orderNo: el.orderNo,
                    guestToken: location.state.guestToken,
                  },
                })
              } else {
                navigate(`/orderrefund`, { state: { orderNo: el.orderNo } })
              }
            }}
          >
            <button type='button'>환불신청</button>
          </div>
          <div className='order_btn'>
            <button
              type='button'
              onClick={() => {
                const CT = new MyChannerlTalk()
                CT.boot({ pluginKey: '168ab92f-c06e-476b-a2cb-95c54ee01572' })
                CT.openChat()
                return () => {
                  CT.shutdown()
                }
              }}
            >
              1:1 문의하기
            </button>
          </div>
        </>
      )}
    </OrderProduct>
  )
}
//배송완료
export function DeliveryCompleted({ el, setSubmit, mypayCoupon, userData, mypayCount }: any) {
  const [lastNumber, setLastNumber] = useState()
  const navigate = useNavigate()
  const location = useLocation()
  const [optionArray, setOptionArray] = useState()
  const [claimArray, setClaimArray] = useState<any>([])
  const [claimText, setClaimText] = useState<any>([])
  const { setIsLottie, hasAccessToken } = useCommonContext()
  useEffect(() => {
    if (el) {
      const array: any = []
      const claimArray: any = []
      const text: any = []
      el?.orderOptionsGroupByPartner[0]?.orderOptionsGroupByDelivery[0]?.orderOptions?.map((el: any) => {
        if (
          el.claimStatusType === 'RETURN_REQUEST' ||
          el.claimStatusType === 'RETURN_REJECT_REQUEST' ||
          el.claimStatusType === 'RETURN_PROC_BEFORE_RECEIVE' ||
          el.claimStatusType === 'RETURN_PROC_REQUEST_REFUND' ||
          el.claimStatusType === 'RETURN_PROC_WAITING_REFUND' ||
          el.claimStatusType === 'RETURN_REJECT_REQUEST' ||
          el.claimStatusType === 'RETURN_DONE' ||
          el.claimStatusType === 'RETURN_REFUND_AMT_ADJUST_REQUESTED' ||
          el.claimStatusType === 'RETURN_NO_REFUND'
        ) {
          claimArray.push(el.orderOptionNo)
          text.push(el.claimStatusType)
        } else if (el.claimStatusType === null) {
          array.push(el.orderOptionNo)
        }
        setOptionArray(array)
        setClaimArray(claimArray)
        setClaimText(text)
      })
    }
  }, [el])

  useEffect(() => {
    if (el?.orderOptionsGroupByPartner[0]) {
      const array: any = []
      el?.orderOptionsGroupByPartner[0]?.orderOptionsGroupByDelivery[0]?.orderOptions.map((element: any) => {
        if (
          element.claimStatusType === 'RETURN_REQUEST' ||
          element.claimStatusType === 'RETURN_REJECT_REQUEST' ||
          element.claimStatusType === 'RETURN_PROC_BEFORE_RECEIVE' ||
          element.claimStatusType === 'RETURN_PROC_REQUEST_REFUND' ||
          element.claimStatusType === 'RETURN_PROC_WAITING_REFUND' ||
          element.claimStatusType === 'RETURN_REJECT_REQUEST' ||
          element.claimStatusType === 'RETURN_DONE' ||
          element.claimStatusType === 'RETURN_REFUND_AMT_ADJUST_REQUESTED' ||
          element.claimStatusType === 'RETURN_NO_REFUND'
        ) {
          array.push(element)
        }
        setLastNumber(array.length)
      })
    }
  }, [el])
  return (
    <OrderProduct>
      <div className='order_product_tit'>
        <div>
          <p>상품 정보</p>
          <em>주문번호 {el?.orderNo}</em>
        </div>
        <span
          style={{
            background:
              claimArray.length !== 0 && claimArray.length === lastNumber ? 'var(--colGray2)' : 'var(--colLightBlue)',
            color:
              claimArray.length !== 0 && claimArray.length === lastNumber ? 'var(--colGray7)' : 'var(--colPointBlue)',
          }}
        >
          {claimArray.length !== 0 && claimArray.length === lastNumber
            ? claimText.includes('RETURN_DONE')
              ? '환불완료'
              : '환불신청'
            : '배송완료'}
        </span>
      </div>
      {el?.orderOptionsGroupByPartner[0]?.orderOptionsGroupByDelivery[0]?.orderOptions.map(
        (element: any, idx: number) => {
          return (
            <OrderDetailListItem
              el={element}
              key={element.optionNo}
              idx={idx}
              lastNumber={lastNumber}
              setIsLottie={setIsLottie}
              setSubmit={setSubmit}
              mypayCoupon={mypayCoupon}
              userData={userData}
              mypayCount={mypayCount}
              pgType={el.pgType}
            ></OrderDetailListItem>
          )
        }
      )}
      {/* {claimArray.length !== 0 && claimArray.length === lastNumber ? (
        <div
          style={{
            padding: '16px 12px',
            borderRadius: '5px',
            background: 'var(--colGray2)',
          }}
        >
          {claimText.includes('RETURN_DONE') ? (
            <p
              style={{
                fontSize: '12px',
                lineHeight: '18px',
                color: 'var(--colGray5)',
                textAlign: 'center',
              }}
            >
              {' '}
              <b
                style={{
                  color: 'var(--colGray6)',
                  display: 'block',
                  marginBottom: '4px',
                }}
              >
                환불이 완료되었습니다.
              </b>
              카드사 결제 취소 처리는
              <br /> 영업일 기준 3~5일까지 소요될 수 있습니다.
            </p>
          ) : (
            <p
              style={{
                fontSize: '12px',
                lineHeight: '18px',
                color: 'var(--colGray5)',
                textAlign: 'center',
              }}
            >
              <b
                style={{
                  color: 'var(--colGray6)',
                  display: 'block',
                  marginBottom: '4px',
                }}
              >
                환불 신청이 완료되었습니다
              </b>
              반품 절차는 택배사 일정에 따라
              <br /> 영업일 기준 5~10일까지 소요될 수 있습니다.
            </p>
          )}
        </div>
      ) : null} */}
      {claimArray.length !== 0 && claimArray.length === lastNumber ? null : (
        <>
          <div
            className='order_btn'
            onClick={() => {
              if (!hasAccessToken) {
                navigate(`/orderrefund`, {
                  state: {
                    orderNo: el.orderNo,
                    guestToken: location.state.guestToken,
                  },
                })
              } else {
                navigate(`/orderrefund`, { state: { orderNo: el.orderNo } })
              }
            }}
          >
            <button type='button'>환불신청</button>
          </div>
          <div className='order_btn'>
            <button
              type='button'
              onClick={() => {
                const CT = new MyChannerlTalk()
                CT.boot({ pluginKey: '168ab92f-c06e-476b-a2cb-95c54ee01572' })
                CT.openChat()
                return () => {
                  CT.shutdown()
                }
              }}
            >
              1:1 문의하기
            </button>
          </div>
        </>
      )}
    </OrderProduct>
  )
}

export function RefundCompleted({ el }: any) {
  const navigate = useNavigate()
  const location = useLocation()
  const [lastNumber, setLastNumber] = useState()

  const [optionArray, setOptionArray] = useState()
  const [claimArray, setClaimArray] = useState<any>([])
  const [claimText, setClaimText] = useState<any>([])

  useEffect(() => {
    if (el) {
      const array: any = []
      const claimArray: any = []
      const text: any = []
      el?.orderOptionsGroupByPartner[0]?.orderOptionsGroupByDelivery[0]?.orderOptions?.map((element: any) => {
        if (
          element.claimStatusType === 'RETURN_REQUEST' ||
          element.claimStatusType === 'RETURN_REJECT_REQUEST' ||
          element.claimStatusType === 'RETURN_PROC_BEFORE_RECEIVE' ||
          element.claimStatusType === 'RETURN_PROC_REQUEST_REFUND' ||
          element.claimStatusType === 'RETURN_PROC_WAITING_REFUND' ||
          element.claimStatusType === 'RETURN_REJECT_REQUEST' ||
          element.claimStatusType === 'RETURN_DONE' ||
          element.claimStatusType === 'RETURN_REFUND_AMT_ADJUST_REQUESTED' ||
          element.claimStatusType === 'RETURN_NO_REFUND'
        ) {
          claimArray.push(element.orderOptionNo)
          text.push(element.claimStatusType)
        } else if (element.claimStatusType === null) {
          array.push(element.orderOptionNo)
        }
        setOptionArray(array)
        setClaimArray(claimArray)
        setClaimText(text)
      })
    }
  }, [el])

  useEffect(() => {
    if (el?.orderOptionsGroupByPartner[0]) {
      const array: any = []
      el?.orderOptionsGroupByPartner[0]?.orderOptionsGroupByDelivery[0]?.orderOptions.map((element: any) => {
        if (
          element.claimStatusType === 'RETURN_REQUEST' ||
          element.claimStatusType === 'RETURN_REJECT_REQUEST' ||
          element.claimStatusType === 'RETURN_PROC_BEFORE_RECEIVE' ||
          element.claimStatusType === 'RETURN_PROC_REQUEST_REFUND' ||
          element.claimStatusType === 'RETURN_PROC_WAITING_REFUND' ||
          element.claimStatusType === 'RETURN_REJECT_REQUEST' ||
          element.claimStatusType === 'RETURN_DONE' ||
          element.claimStatusType === 'RETURN_REFUND_AMT_ADJUST_REQUESTED' ||
          element.claimStatusType === 'RETURN_NO_REFUND'
        ) {
          array.push(element)
        }
        setLastNumber(array.length)
      })
    }
  }, [el])
  return (
    <OrderProduct>
      <div className='order_product_tit'>
        <div>
          <p>상품 정보</p>
          <em>주문번호 {el?.orderNo}</em>
        </div>
        <span style={{ background: 'var(--colGray2)', color: 'var(--colGray7)' }}>
          {claimText.includes('RETURN_DONE') ? '환불완료' : '환불신청'}
        </span>
      </div>
      {el?.orderOptionsGroupByPartner[0]?.orderOptionsGroupByDelivery[0]?.orderOptions.map((el: any, idx: number) => {
        return <OrderDetailListItem el={el} key={el.optionNo} idx={idx} lastNumber={lastNumber}></OrderDetailListItem>
      })}
      {/* <div
        style={{
          padding: '16px 12px',
          borderRadius: '5px',
          background: 'var(--colGray2)',
        }}
      >
        <p
          style={{
            fontSize: '12px',
            lineHeight: '18px',
            color: 'var(--colGray5)',
            textAlign: 'center',
          }}
        >
          <b
            style={{
              color: 'var(--colGray6)',
              display: 'block',
              marginBottom: '4px',
            }}
          >
            환불이 완료되었습니다.
          </b>
          카드사 결제 취소 처리는
          <br /> 영업일 기준 3~5일까지 소요될 수 있습니다.
        </p>
      </div> */}
      {/* <div className="order_btn">
        <button type="button">구매확정</button>
        <button
          type="button"
          onClick={() => {
            if (!accessToken) {
              navigate(`/orderrefund`, {
                state: {
                  orderNo: el.orderNo,
                  guestToken: location.state.guestToken,
                },
              });
            } else {
              navigate(`/orderrefund`, { state: { orderNo: el.orderNo } });
            }
          }}
        >
          환불신청
        </button>
      </div> */}
    </OrderProduct>
  )
}

export function BuyConfirm({ el, setSubmit, mypayCoupon, userData, mypayCount }: any) {
  const [lastNumber, setLastNumber] = useState()

  const [optionArray, setOptionArray] = useState()
  const [claimArray, setClaimArray] = useState<any>([])
  const [claimText, setClaimText] = useState<any>([])
  const { setIsLottie } = useCommonContext()

  useEffect(() => {
    if (el) {
      const array: any = []
      const claimArray: any = []
      const text: any = []
      el?.orderOptionsGroupByPartner[0]?.orderOptionsGroupByDelivery[0]?.orderOptions?.map((element: any) => {
        if (
          element.claimStatusType === 'RETURN_REQUEST' ||
          element.claimStatusType === 'RETURN_REJECT_REQUEST' ||
          element.claimStatusType === 'RETURN_PROC_BEFORE_RECEIVE' ||
          element.claimStatusType === 'RETURN_PROC_REQUEST_REFUND' ||
          element.claimStatusType === 'RETURN_PROC_WAITING_REFUND' ||
          element.claimStatusType === 'RETURN_REJECT_REQUEST' ||
          element.claimStatusType === 'RETURN_DONE' ||
          element.claimStatusType === 'RETURN_REFUND_AMT_ADJUST_REQUESTED' ||
          element.claimStatusType === 'RETURN_NO_REFUND'
        ) {
          claimArray.push(element.orderOptionNo)
          text.push(element.claimStatusType)
        } else if (element.claimStatusType === null) {
          array.push(element.orderOptionNo)
        }
        setOptionArray(array)
        setClaimArray(claimArray)
        setClaimText(text)
      })
    }
  }, [el])

  useEffect(() => {
    if (el?.orderOptionsGroupByPartner[0]) {
      const array: any = []
      el?.orderOptionsGroupByPartner[0]?.orderOptionsGroupByDelivery[0]?.orderOptions.map((element: any) => {
        if (
          element.claimStatusType === 'RETURN_REQUEST' ||
          element.claimStatusType === 'RETURN_REJECT_REQUEST' ||
          element.claimStatusType === 'RETURN_PROC_BEFORE_RECEIVE' ||
          element.claimStatusType === 'RETURN_PROC_REQUEST_REFUND' ||
          element.claimStatusType === 'RETURN_PROC_WAITING_REFUND' ||
          element.claimStatusType === 'RETURN_REJECT_REQUEST' ||
          element.claimStatusType === 'RETURN_DONE' ||
          element.claimStatusType === 'RETURN_REFUND_AMT_ADJUST_REQUESTED' ||
          element.claimStatusType === 'RETURN_NO_REFUND'
        ) {
          array.push(element)
        }
        setLastNumber(array.length)
      })
    }
  }, [el])
  return (
    <OrderProduct>
      <div className='order_product_tit'>
        <div>
          <p>상품 정보</p>
          <em>주문번호 {el?.orderNo}</em>
        </div>
        <span className='g_color'>
          {claimArray.length !== 0 && claimArray.length === lastNumber
            ? claimText.includes('RETURN_DONE')
              ? '환불완료'
              : '환불신청'
            : '구매확정'}
        </span>
      </div>
      {el?.orderOptionsGroupByPartner[0]?.orderOptionsGroupByDelivery[0]?.orderOptions.map(
        (element: any, idx: number) => {
          if (element.claimStatusType !== 'CANCEL_REQUEST')
            return (
              <OrderDetailListItem
                el={element}
                key={element.optionNo}
                idx={idx}
                lastNumber={lastNumber}
                setSubmit={setSubmit}
                mypayCoupon={mypayCoupon}
                userData={userData}
                mypayCount={mypayCount}
                pgType={el.pgType}
              ></OrderDetailListItem>
            )
        }
      )}

      {/* <div className='order_btn'>
        <button type='button'>전체상품 다시 담기</button>
      </div> */}
    </OrderProduct>
  )
}

export function CancelDone({ el }: any) {
  const [lastNumber, setLastNumber] = useState()

  useEffect(() => {
    if (el?.orderOptionsGroupByPartner[0]) {
      setLastNumber(el?.orderOptionsGroupByPartner[0]?.orderOptionsGroupByDelivery[0]?.orderOptions.length)
    }
  }, [el])
  return (
    <OrderProduct>
      <div className='order_product_tit'>
        <div>
          <p>상품 정보</p>
          <em>주문번호 {el?.orderNo}</em>
        </div>
        <span className='g_color'>주문취소완료</span>
      </div>
      {el?.orderOptionsGroupByPartner[0]?.orderOptionsGroupByDelivery[0]?.orderOptions.map((el: any, idx: number) => {
        return <OrderDetailListItem el={el} key={el.optionNo} idx={idx} lastNumber={lastNumber}></OrderDetailListItem>
      })}
    </OrderProduct>
  )
}

//리스트 아이템
export function OrderDetailListItem({
  el,
  idx,
  setIsLottie,
  setSubmit,
  mypayCoupon,
  userData,
  mypayCount,
  pgType,
}: any) {
  const { isAppView } = useAppContext()
  const { hasAccessToken } = useCommonContext()
  const navigate = useNavigate()
  const location = useLocation()

  const [lastItem, setLastItem] = useState(false)
  const [optionArray, setOptionArray] = useState()
  const [claimArray, setClaimArray] = useState<any>([])
  const [claimText, setClaimText] = useState<any>([])
  const [url, setUrl] = useState('')
  const [reviewable, setReiveable] = useState(false)
  const [lastNumber, setLastNumber] = useState<any>()
  const [myReview, setMyReview] = useState<any>({})

  useEffect(() => {
    if (hasAccessToken) {
      getMyReview().then((res) => {
        res.data.items.forEach((item: any) => {
          if (item.orderNo === el.orderNo) {
            setMyReview(item)
          }
        })
      })
    }
  }, [])

  useEffect(() => {
    if (el) {
      const array: any = []
      const claimArray: any = []
      const text: any = []

      if (
        el.claimStatusType === 'RETURN_REQUEST' ||
        el.claimStatusType === 'RETURN_REJECT_REQUEST' ||
        el.claimStatusType === 'RETURN_PROC_BEFORE_RECEIVE' ||
        el.claimStatusType === 'RETURN_PROC_REQUEST_REFUND' ||
        el.claimStatusType === 'RETURN_PROC_WAITING_REFUND' ||
        el.claimStatusType === 'RETURN_REJECT_REQUEST' ||
        el.claimStatusType === 'RETURN_DONE' ||
        el.claimStatusType === 'RETURN_REFUND_AMT_ADJUST_REQUESTED' ||
        el.claimStatusType === 'RETURN_NO_REFUND'
      ) {
        claimArray.push(el.orderOptionNo)
        text.push(el.claimStatusType)
      } else if (el.claimStatusType === null) {
        array.push(el.orderOptionNo)
      }
      setOptionArray(array)
      setClaimArray(claimArray)
      setClaimText(text)
    }
  }, [el])

  useEffect(() => {
    if (el) {
      const array: any = []

      if (
        el.claimStatusType === 'RETURN_REQUEST' ||
        el.claimStatusType === 'RETURN_REJECT_REQUEST' ||
        el.claimStatusType === 'RETURN_PROC_BEFORE_RECEIVE' ||
        el.claimStatusType === 'RETURN_PROC_REQUEST_REFUND' ||
        el.claimStatusType === 'RETURN_PROC_WAITING_REFUND' ||
        el.claimStatusType === 'RETURN_REJECT_REQUEST' ||
        el.claimStatusType === 'RETURN_DONE' ||
        el.claimStatusType === 'RETURN_REFUND_AMT_ADJUST_REQUESTED' ||
        el.claimStatusType === 'RETURN_NO_REFUND'
      ) {
        array.push(el)
      }
      setLastNumber(array.length)
    }
  }, [el])
  useEffect(() => {
    if (el) {
      setUrl(el.delivery.retrieveInvoiceUrl)
    }
  }, [el])

  useEffect(() => {
    if (hasAccessToken) {
      getReviewableProduct(el.productNo).then((res) => {
        setReiveable(res.data.reviewable)
      })
    }
  }, [])

  useEffect(() => {
    if (Number(idx + 1) === Number(lastNumber)) {
      setLastItem(true)
    }
  }, [])
  return (
    <div className='order_item' key={el?.orderOptionNo}>
      <div
        className={
          el.orderStatusType === 'CANCEL_DONE' ||
          el.orderStatusType === 'RETURN_DONE' ||
          el.claimStatusType === 'CANCEL_REQUEST' ||
          el.claimStatusType === 'RETURN_REQUEST' ||
          el.claimStatusType === 'RETURN_REJECT_REQUEST' ||
          el.claimStatusType === 'RETURN_PROC_BEFORE_RECEIVE' ||
          el.claimStatusType === 'RETURN_PROC_REQUEST_REFUND' ||
          el.claimStatusType === 'RETURN_PROC_WAITING_REFUND' ||
          el.claimStatusType === 'RETURN_REJECT_REQUEST' ||
          el.claimStatusType === 'RETURN_DONE' ||
          el.claimStatusType === 'RETURN_REFUND_AMT_ADJUST_REQUESTED' ||
          el.claimStatusType === 'RETURN_NO_REFUND'
            ? 'g_color'
            : ''
        }
        style={{
          display: 'flex',
          gap: 20,
          flexDirection: 'column',
          paddingBottom: '23px',
          borderBottom: lastItem ? 'none' : '1px solid var(--colGray3)',
          marginTop: '24px',
        }}
      >
        <div style={{ display: 'flex', gap: 20, alignItems: 'flex-start' }}>
          {/* 이미지 */}
          <div
            onClick={() => {
              if (isAppView) {
                RNPostMessage(AFWebLinkType.moveToLink, {
                  url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/product/${el?.productNo}`,
                })
              } else {
                navigate(`/product/${el?.productNo}`)
              }
            }}
          >
            <div className='img_box'>
              <div className='dim'></div>
              <img
                src={el.imageUrl}
                alt='productImage'
                style={{
                  width: isMobile ? 80 : 100,
                  height: isMobile ? 80 : 100,
                  borderRadius: 10,
                }}
              />
            </div>
          </div>

          {/* 브랜드 타이틀 */}
          <div style={{ flex: 1 }}>
            <div
              onClick={() => {
                if (isAppView) {
                  RNPostMessage(AFWebLinkType.moveToLink, {
                    url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/product/${el?.productNo}`,
                  })
                } else {
                  navigate(`/product/${el?.productNo}`)
                }
              }}
            >
              <p
                style={{
                  color: 'var(--colBlack)',
                  fontSize: 12,
                  fontWeight: 700,
                  lineHeight: '14px',
                }}
              >
                {el?.brandName}
              </p>

              {/* 상품 타이틀 */}
              <p
                style={{
                  color: 'var(--colBlack)',
                  textOverflow: 'ellipsis',
                  fontSize: isMobile ? 14 : 16,
                  fontWeight: 500,
                  lineHeight: isMobile ? '18px' : '20px',
                  marginTop: 4,
                }}
              >
                {el?.productName}
              </p>

              {/* 옵션 */}
              <p
                style={{
                  marginTop: 10,
                  color: 'var(--colGray6)',
                  fontSize: isMobile ? 12 : 15,
                  fontWeight: 500,
                  lineHeight: isMobile ? '16px' : '20px',
                }}
              >
                옵션 : {el?.optionTitle.split(': ')[1] ? el?.optionTitle.split(': ')[1] : el?.optionTitle}
              </p>

              {/* 수량 */}
              <p
                style={{
                  marginTop: 4,
                  color: 'var(--colGray6)',
                  fontSize: isMobile ? 12 : 15,
                  fontWeight: 500,
                  lineHeight: isMobile ? '16px' : '20px',
                }}
              >
                수량 : {el?.orderCnt}개
              </p>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'flex-end',
                }}
              >
                <div style={{ marginBottom: isMobile ? '16px' : '0px' }}>
                  {Math.floor((el.price?.immediateDiscountAmt / (el?.price?.salePrice + el?.price?.addPrice)) * 100) ===
                  0 ? (
                    <>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          marginTop: '10px',
                        }}
                      >
                        <div style={{ display: 'flex', gap: 6 }}>
                          <p
                            style={{
                              color: 'var(--colBlack)',
                              fontSize: isMobile ? 15 : 18,
                              fontWeight: 600,
                              lineHeight: isMobile ? '18px' : '22px',
                            }}
                          >
                            {plusComma(el?.price?.buyAmt)}원
                          </p>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <p
                        style={{
                          marginTop: 10,
                          color: 'var(--colGray6)',
                          fontSize: isMobile ? 12 : 14,
                          fontWeight: 500,
                          lineHeight: '16px',
                          textDecoration: 'line-through',
                        }}
                      >
                        {plusComma(el?.price?.standardAmt)}원
                      </p>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          marginTop: '2px',
                        }}
                      >
                        <div style={{ display: 'flex', gap: 6 }}>
                          <p
                            style={{
                              color: 'var(--colPointOrange)',
                              fontSize: isMobile ? 15 : 18,
                              fontWeight: 600,
                              lineHeight: isMobile ? '18px' : '22px',
                            }}
                          >
                            {Math.floor(
                              (el.price?.immediateDiscountAmt / (el?.price?.salePrice + el?.price?.addPrice)) * 100
                            )}
                            %
                          </p>
                          <p
                            style={{
                              color: 'var(--colBlack)',
                              fontSize: isMobile ? 15 : 18,
                              fontWeight: 600,
                              lineHeight: isMobile ? '18px' : '22px',
                            }}
                          >
                            {plusComma(el?.price?.buyAmt)}원
                          </p>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
            {/* 주문상태에 따른 버튼 */}
            {location.pathname.includes('complete') ? null : el.claimStatusType === 'RETURN_REQUEST' ||
              el.claimStatusType === 'RETURN_REJECT_REQUEST' ||
              el.claimStatusType === 'RETURN_PROC_BEFORE_RECEIVE' ||
              el.claimStatusType === 'RETURN_PROC_REQUEST_REFUND' ||
              el.claimStatusType === 'RETURN_PROC_WAITING_REFUND' ||
              el.claimStatusType === 'RETURN_DONE' ? null : el.orderStatusType === 'PAY_DONE' ||
              el.orderStatusType === 'PRODUCT_PREPARE' ||
              el.orderStatusType === 'DELIVERY_PREPARE' ||
              el.orderStatusType === 'CANCEL_DONE' ? null : el.orderStatusType === 'DELIVERY_DONE' ? (
              el.orderStatusType === 'DELIVERY_ING' ? (
                <div
                  style={{
                    marginTop: isMobile ? '16px' : '20px',
                    display: 'flex',
                    gap: '8px',
                  }}
                >
                  <button
                    type='button'
                    style={{
                      fontSize: '12px',
                      lineHeight: '16px',
                      color: 'var(--colGray7)',
                      padding: '5px 11px',
                      border: '1px solid var(--colGray3)',
                      borderRadius: '5px',
                      background: 'transparent',
                      minWidth: '66px',
                      textAlign: 'center',
                      cursor: 'pointer',
                    }}
                  >
                    <Link
                      to={url}
                      style={{ width: '100%', height: '100%' }}
                      onClick={(e) => {
                        const app = getParsedSessionStorageItem('app')
                        if (app) {
                          e.preventDefault()
                          // moveToLinkNaver(url);
                          handlePostMessage({ actionType: 'moveToLinkNaver', params: { url: url } })
                        }
                      }}
                    >
                      배송조회
                    </Link>
                  </button>
                </div>
              ) : (
                <div
                  style={{
                    marginTop: isMobile ? '16px' : '20px',
                    display: 'flex',
                    gap: '8px',
                  }}
                >
                  <button
                    type='button'
                    style={{
                      fontSize: '12px',
                      lineHeight: '16px',
                      color: 'var(--colGray7)',
                      padding: '5px 11px',
                      border: '1px solid var(--colGray3)',
                      borderRadius: '5px',
                      background: 'transparent',
                      minWidth: '66px',
                      textAlign: 'center',
                      cursor: 'pointer',
                    }}
                    onClick={() => {
                      const confirmed = window.confirm('상품 구매확정을 하시겠습니까?')
                      if (confirmed) {
                        if (hasAccessToken) {
                          if (pgType === 'MY_PAY') {
                            putUserConfirm(el.orderOptionNo)
                              .then((res) => {
                                setSubmit((prev: boolean) => !prev)
                                alert('구매확정이 완료되었습니다.')
                                const price =
                                  (Number(el.price.salePrice) - Number(el.price.immediateDiscountAmt)) * 0.02
                                postPromotion('uu6weWziAWYWvcGvy2yY')
                                  .then((res: any) => {
                                    postMypayAcc(userData.memberNo, el.orderOptionNo, price)
                                      .then((res) => {
                                        if (res.data.code === 'E0805') {
                                          alert('이미 지급 되었습니다.')
                                        } else if (res.data.code === 'E9803') {
                                        } else if (res.data.code === 'E0603') {
                                        } else {
                                          alert(
                                            '어바웃피싱 페이 이용 혜택으로 쿠폰과 추가 페이백이 지급되었습니다. 마이쇼핑에서 확인해 보세요.'
                                          )
                                        }
                                      })
                                      .catch((err) => {
                                        alert('잠시후 시도해 주세요')
                                      })
                                  })
                                  .catch((err) => {
                                    postMypayAcc(userData.memberNo, el.orderOptionNo, price)
                                      .then((res) => {
                                        if (res.data.code === 'E0805') {
                                          alert('이미 지급 되었습니다.')
                                        } else if (res.data.code === 'E9803') {
                                        } else if (res.data.code === 'E0603') {
                                        } else {
                                          alert(
                                            '어바웃피싱 페이 이용 혜택으로 추가 페이백이 지급되었습니다. 마이쇼핑에서 확인해 보세요.'
                                          )
                                        }
                                      })
                                      .catch((err) => {
                                        alert('잠시후 시도해 주세요')
                                      })
                                  })
                              })
                              .catch((err) => {
                                console.log(err)
                                alert('잠시후에 시도해 주세요')
                              })
                          } else {
                            putUserConfirm(el.orderOptionNo)
                              .then((res) => {
                                setSubmit((prev: boolean) => !prev)
                                alert('구매확정이 완료되었습니다.')
                              })
                              .catch((err) => {
                                console.log(err)
                                alert('잠시후에 시도해 주세요')
                              })
                          }
                        } else {
                          putGuestConfirm(el.orderOptionNo, location.state.guestToken)
                            .then((res) => {
                              setSubmit((prev: boolean) => !prev)
                              alert('구매확정이 완료되었습니다.')
                            })
                            .catch((err) => {
                              console.log(err)
                            })
                        }
                      }
                    }}
                  >
                    구매확정
                  </button>
                  <button
                    type='button'
                    style={{
                      fontSize: '12px',
                      lineHeight: '16px',
                      color: 'var(--colGray7)',
                      padding: '5px 11px',
                      border: '1px solid var(--colGray3)',
                      borderRadius: '5px',
                      background: 'transparent',
                      minWidth: '66px',
                      textAlign: 'center',
                      cursor: 'pointer',
                    }}
                  >
                    <Link
                      to={url}
                      style={{ width: '100%', height: '100%' }}
                      onClick={(e) => {
                        const app = getParsedSessionStorageItem('app')
                        if (app) {
                          e.preventDefault()
                          // moveToLinkNaver(url);
                          handlePostMessage({ actionType: 'moveToLinkNaver', params: { url: url } })
                        }
                      }}
                    >
                      배송조회
                    </Link>
                  </button>
                </div>
              )
            ) : el?.orderStatusType === 'BUY_CONFIRM' ? null : (
              <div style={{ marginTop: isMobile ? '16px' : '20px' }}>
                <button
                  type='button'
                  style={{
                    fontSize: '12px',
                    lineHeight: '16px',
                    color: 'var(--colGray7)',
                    padding: '5px 11px',
                    border: '1px solid var(--colGray3)',
                    borderRadius: '5px',
                    background: 'transparent',
                    minWidth: '66px',
                    textAlign: 'center',
                    cursor: 'pointer',
                  }}
                >
                  <Link
                    to={url}
                    style={{ width: '100%', height: '100%' }}
                    onClick={(e) => {
                      const app = getParsedSessionStorageItem('app')
                      if (app) {
                        e.preventDefault()
                        // moveToLinkNaver(url);
                        handlePostMessage({ actionType: 'moveToLinkNaver', params: { url: url } })
                      }
                    }}
                  >
                    배송조회
                  </Link>
                </button>
              </div>
            )}
            {location.pathname.includes('complete') ? null : el?.orderStatusType === 'BUY_CONFIRM' ? (
              reviewable ? (
                <div style={{ marginTop: isMobile ? '16px' : '20px' }}>
                  <button
                    type='button'
                    style={{
                      fontSize: '12px',
                      lineHeight: '16px',
                      color: 'var(--colWhite)',
                      padding: '5px 11px',
                      border: '1px solid var(--colBlack)',
                      borderRadius: '5px',
                      background: 'var(--colBlack)',
                      minWidth: '66px',
                      textAlign: 'center',
                      cursor: 'pointer',
                    }}
                    onClick={() => {
                      if (myReview) {
                        if (isAppView) {
                          RNPostMessage(AFWebLinkType.moveToLink, {
                            url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/reviewwrite/${el.productNo}?reviewNo=${myReview.reviewNo}&productNo=${el.productNo}&orderNo=${el.orderNo}`,
                          })
                        } else {
                          navigate(`/reviewwrite/${el.productNo}`, {
                            state: {
                              reviewNo: myReview.reviewNo,
                              productNo: el.productNo,
                              orderNo: el.orderNo,
                            },
                          })
                        }
                      } else {
                        if (isAppView) {
                          RNPostMessage(AFWebLinkType.moveToLink, {
                            url: `aboutfishing://aboutfishing.com/?page=webview&url=${
                              process.env.REACT_APP_SHOP_URL
                            }/reviewwrite/${el.productNo}?reviewNo=null&productNo=${el.productNo}&orderNo=${
                              el.orderNo
                            }&optionValue=${el.optionValue || null}`,
                          })
                        } else {
                          navigate(`/reviewwrite/${el.productNo}`, {
                            state: {
                              reviewNo: null,
                              productNo: el.productNo,
                              orderNo: el.orderNo,
                              optionValue: el.optionValue || null,
                            },
                          })
                        }
                      }
                    }}
                  >
                    리뷰작성
                  </button>
                </div>
              ) : null
            ) : null}
          </div>
        </div>
        {claimArray.length !== 0 && claimArray.length === lastNumber ? (
          <div
            style={{
              padding: '16px 12px',
              borderRadius: '5px',
              background: 'var(--colGray2)',
            }}
          >
            {claimText.includes('RETURN_DONE') ? (
              <p
                style={{
                  fontSize: '12px',
                  lineHeight: '18px',
                  color: 'var(--colGray5)',
                  textAlign: 'center',
                }}
              >
                {' '}
                <b
                  style={{
                    color: 'var(--colGray6)',
                    display: 'block',
                    marginBottom: '4px',
                  }}
                >
                  환불이 완료되었습니다.
                </b>
                카드사 결제 취소 처리는
                <br /> 영업일 기준 3~5일까지 소요될 수 있습니다.
              </p>
            ) : (
              <p
                style={{
                  fontSize: '12px',
                  lineHeight: '18px',
                  color: 'var(--colGray5)',
                  textAlign: 'center',
                }}
              >
                <b
                  style={{
                    color: 'var(--colGray6)',
                    display: 'block',
                    marginBottom: '4px',
                  }}
                >
                  환불 신청이 완료되었습니다
                </b>
                반품 절차는 택배사 일정에 따라
                <br /> 영업일 기준 5~10일까지 소요될 수 있습니다.
              </p>
            )}
          </div>
        ) : null}
      </div>
    </div>
  )
}

export function OrderDetailCancelItem({
  el,
  idx,
  lastNumber,
  setIsLottie,
  setSubmit,
  userData,
  mypayCount,
  pgType,
}: any) {
  const { isAppView } = useAppContext()
  const { hasAccessToken } = useCommonContext()
  const navigate = useNavigate()
  const location = useLocation()

  const [lastItem, setLastItem] = useState(false)
  const [url, setUrl] = useState('')

  useEffect(() => {
    if (el) {
      setUrl(el.delivery.retrieveInvoiceUrl)
    }
  }, [el])

  useEffect(() => {
    if (Number(idx + 1) === Number(lastNumber)) {
      setLastItem(true)
    }
  }, [])
  return (
    <div className='order_item' key={el?.orderOptionNo}>
      <div
        className={
          el.orderStatusType === 'CANCEL_DONE' ||
          el.orderStatusType === 'RETURN_DONE' ||
          el.claimStatusType === 'CANCEL_REQUEST'
            ? 'g_color'
            : ''
        }
        style={{
          display: 'flex',
          gap: 20,
          flexDirection: 'column',
          paddingBottom: '23px',
          borderBottom: lastItem ? 'none' : '1px solid var(--colGray3)',
          marginTop: '24px',
        }}
      >
        <div style={{ display: 'flex', gap: 20, alignItems: 'flex-start' }}>
          {/* 이미지 */}
          <div className='img_box'>
            <div className='dim'></div>
            <img
              src={el.imageUrl}
              alt='productImage'
              style={{
                width: isMobile ? 80 : 100,
                height: isMobile ? 80 : 100,
                borderRadius: 10,
              }}
            />
          </div>

          {/* 브랜드 타이틀 */}
          <div style={{ flex: 1 }}>
            <p
              style={{
                color: 'var(--colBlack)',
                fontSize: 12,
                fontWeight: 700,
                lineHeight: '14px',
              }}
            >
              {el?.brandName}
            </p>

            {/* 상품 타이틀 */}
            <p
              style={{
                color: 'var(--colBlack)',
                textOverflow: 'ellipsis',
                fontSize: isMobile ? 14 : 16,
                fontWeight: 500,
                lineHeight: isMobile ? '18px' : '20px',
                marginTop: 4,
              }}
            >
              {el?.productName}
            </p>

            {/* 옵션 */}
            <p
              style={{
                marginTop: 10,
                color: 'var(--colGray6)',
                fontSize: isMobile ? 12 : 15,
                fontWeight: 500,
                lineHeight: isMobile ? '16px' : '20px',
              }}
            >
              옵션 : {el?.optionTitle.split(': ')[1] ? el?.optionTitle.split(': ')[1] : el?.optionTitle}
            </p>

            {/* 수량 */}
            <p
              style={{
                marginTop: 4,
                color: 'var(--colGray6)',
                fontSize: isMobile ? 12 : 15,
                fontWeight: 500,
                lineHeight: isMobile ? '16px' : '20px',
              }}
            >
              수량 : {el?.orderCnt}개
            </p>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-end',
              }}
            >
              {Math.floor((el.price?.immediateDiscountAmt / (el?.price?.salePrice + el?.price?.addPrice)) * 100) ===
              0 ? (
                <>
                  <div style={{ marginBottom: isMobile ? '16px' : '0px' }}>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginTop: '10px',
                      }}
                    >
                      <div style={{ display: 'flex', gap: 6 }}>
                        <p
                          style={{
                            color: 'var(--colBlack)',
                            fontSize: isMobile ? 15 : 18,
                            fontWeight: 600,
                            lineHeight: isMobile ? '18px' : '22px',
                          }}
                        >
                          {plusComma(el?.price?.salePrice + el?.price?.addPrice - el.price.immediateDiscountAmt)}원
                        </p>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div style={{ marginBottom: isMobile ? '16px' : '0px' }}>
                    <p
                      style={{
                        marginTop: 10,
                        color: 'var(--colGray6)',
                        fontSize: isMobile ? 12 : 14,
                        fontWeight: 500,
                        lineHeight: '16px',
                        textDecoration: 'line-through',
                      }}
                    >
                      {plusComma(el?.price?.standardAmt)}원
                    </p>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginTop: '2px',
                      }}
                    >
                      <div style={{ display: 'flex', gap: 6 }}>
                        <p
                          style={{
                            color: 'var(--colPointOrange)',
                            fontSize: isMobile ? 15 : 18,
                            fontWeight: 600,
                            lineHeight: isMobile ? '18px' : '22px',
                          }}
                        >
                          {Math.floor(
                            (el.price?.immediateDiscountAmt / (el?.price?.salePrice + el?.price?.addPrice)) * 100
                          )}
                          %
                        </p>
                        <p
                          style={{
                            color: 'var(--colBlack)',
                            fontSize: isMobile ? 15 : 18,
                            fontWeight: 600,
                            lineHeight: isMobile ? '18px' : '22px',
                          }}
                        >
                          {plusComma(el?.price?.salePrice + el?.price?.addPrice - el.price.immediateDiscountAmt)}원
                        </p>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
            {/* 주문상태에 따른 버튼 */}
            {location.pathname.includes('complete') ? null : el.claimStatusType === 'RETURN_REQUEST' ||
              el.claimStatusType === 'RETURN_REJECT_REQUEST' ||
              el.claimStatusType === 'RETURN_PROC_BEFORE_RECEIVE' ||
              el.claimStatusType === 'RETURN_PROC_REQUEST_REFUND' ||
              el.claimStatusType === 'RETURN_PROC_WAITING_REFUND' ||
              el.claimStatusType === 'RETURN_DONE' ? null : el.orderStatusType === 'PAY_DONE' ||
              el.orderStatusType === 'PRODUCT_PREPARE' ||
              el.orderStatusType === 'DELIVERY_PREPARE' ||
              el.orderStatusType === 'CANCEL_DONE' ? null : el.orderStatusType === 'PRODUCT_PREPARE' ||
              el.orderStatusType === 'DELIVERY_DONE' ? (
              <div
                style={{
                  marginTop: isMobile ? '16px' : '20px',
                  display: 'flex',
                  gap: '8px',
                }}
              >
                <button
                  type='button'
                  style={{
                    fontSize: '12px',
                    lineHeight: '16px',
                    color: 'var(--colGray7)',
                    padding: '5px 11px',
                    border: '1px solid var(--colGray3)',
                    borderRadius: '5px',
                    background: 'transparent',
                    minWidth: '66px',
                    textAlign: 'center',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    const confirmed = window.confirm('상품 구매확정을 하시겠습니까?')
                    if (confirmed) {
                      if (hasAccessToken) {
                        if (pgType === 'MY_PAY') {
                          putUserConfirm(el.orderOptionNo)
                            .then((res) => {
                              setSubmit((prev: boolean) => !prev)
                              alert('구매확정이 완료되었습니다.')
                              const price = (Number(el.price.salePrice) - Number(el.price.immediateDiscountAmt)) * 0.02
                              postPromotion('uu6weWziAWYWvcGvy2yY')
                                .then((res: any) => {
                                  postMypayAcc(userData.memberNo, el.orderOptionNo, price)
                                    .then((res) => {
                                      if (res.data.code === 'E0805') {
                                        alert('이미 지급 되었습니다.')
                                      } else if (res.data.code === 'E9803') {
                                      } else if (res.data.code === 'E0603') {
                                      } else {
                                        alert(
                                          '어바웃피싱 페이 이용 혜택으로 쿠폰과 추가 페이백이 지급되었습니다. 마이쇼핑에서 확인해 보세요.'
                                        )
                                      }
                                    })
                                    .catch((err) => {
                                      alert('잠시후 시도해 주세요')
                                    })
                                })
                                .catch((err) => {
                                  postMypayAcc(userData.memberNo, el.orderOptionNo, price)
                                    .then((res) => {
                                      if (res.data.code === 'E0805') {
                                        alert('이미 지급 되었습니다.')
                                      } else if (res.data.code === 'E9803') {
                                      } else if (res.data.code === 'E0603') {
                                      } else {
                                        alert(
                                          '어바웃피싱 페이 이용 혜택으로 추가 페이백이 지급되었습니다. 마이쇼핑에서 확인해 보세요.'
                                        )
                                      }
                                    })
                                    .catch((err) => {
                                      alert('잠시후 시도해 주세요')
                                    })
                                })
                            })
                            .catch((err) => {
                              console.log(err)
                              alert('잠시후에 시도해 주세요')
                            })
                        } else {
                          putUserConfirm(el.orderOptionNo)
                            .then((res) => {
                              setSubmit((prev: boolean) => !prev)
                              alert('구매확정이 완료되었습니다.')
                            })
                            .catch((err) => {
                              console.log(err)
                              alert('잠시후에 시도해 주세요')
                            })
                        }
                      } else {
                        putGuestConfirm(el.orderOptionNo, location.state.guestToken)
                          .then((res) => {
                            setSubmit((prev: boolean) => !prev)
                            alert('구매확정이 완료되었습니다.')
                          })
                          .catch((err) => {
                            console.log(err)
                          })
                      }
                    }
                  }}
                >
                  구매확정
                </button>
                <button
                  type='button'
                  style={{
                    fontSize: '12px',
                    lineHeight: '16px',
                    color: 'var(--colGray7)',
                    padding: '5px 11px',
                    border: '1px solid var(--colGray3)',
                    borderRadius: '5px',
                    background: 'transparent',
                    minWidth: '66px',
                    textAlign: 'center',
                    cursor: 'pointer',
                  }}
                >
                  <Link
                    to={url}
                    style={{ width: '100%', height: '100%' }}
                    onClick={(e) => {
                      const app = getParsedSessionStorageItem('app')
                      if (app) {
                        e.preventDefault()
                        // moveToLinkNaver(url);
                        handlePostMessage({ actionType: 'moveToLinkNaver', params: { url: url } })
                      }
                    }}
                  >
                    배송조회
                  </Link>
                </button>
              </div>
            ) : el?.orderStatusType === 'BUY_CONFIRM' ? null : (
              <div style={{ marginTop: isMobile ? '16px' : '20px' }}>
                <button
                  type='button'
                  style={{
                    fontSize: '12px',
                    lineHeight: '16px',
                    color: 'var(--colGray7)',
                    padding: '5px 11px',
                    border: '1px solid var(--colGray3)',
                    borderRadius: '5px',
                    background: 'transparent',
                    minWidth: '66px',
                    textAlign: 'center',
                    cursor: 'pointer',
                  }}
                >
                  <Link
                    to={url}
                    style={{ width: '100%', height: '100%' }}
                    onClick={(e) => {
                      const app = getParsedSessionStorageItem('app')
                      if (app) {
                        e.preventDefault()
                        // moveToLinkNaver(url);
                        handlePostMessage({ actionType: 'moveToLinkNaver', params: { url: url } })
                      }
                    }}
                  >
                    배송조회
                  </Link>
                </button>
              </div>
            )}
            {location.pathname.includes('complete') ? null : el?.orderStatusType === 'BUY_CONFIRM' ? (
              <div style={{ marginTop: isMobile ? '16px' : '20px' }}>
                <button
                  type='button'
                  style={{
                    fontSize: '12px',
                    lineHeight: '16px',
                    color: 'var(--colWhite)',
                    padding: '5px 11px',
                    border: '1px solid var(--colBlack)',
                    borderRadius: '5px',
                    background: 'var(--colBlack)',
                    minWidth: '66px',
                    textAlign: 'center',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    if (isAppView) {
                      RNPostMessage(AFWebLinkType.moveToLink, {
                        url: `aboutfishing://aboutfishing.com/?page=webview&url=${
                          process.env.REACT_APP_SHOP_URL
                        }/reviewwrite/${el.productNo}?reviewNo=null&productNo=${el.productNo}&orderNo=${
                          el.orderNo
                        }&optionValue=${el.optionValue || null}`,
                      })
                    } else {
                      navigate(`/reviewwrite/${el.productNo}`, {
                        state: {
                          reviewNo: null,
                          productNo: el.productNo,
                          orderNo: el.orderNo,
                          optionValue: el.optionValue || null,
                        },
                      })
                    }
                  }}
                >
                  리뷰작성
                </button>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  )
}

/*<div
              style={{
                padding: "16px 12px",
                borderRadius: "5px",
                background: "var(--colGray2)",
              }}
            >
              <p
                style={{
                  fontSize: "12px",
                  lineHeight: "18px",
                  color: "var(--colGray5)",
                  textAlign: "center",
                }}
              >
                <b
                  style={{
                    color: "var(--colGray6)",
                    display: "block",
                    marginBottom: "4px",
                  }}
                >
                  환불 신청이 완료되었습니다
                </b>
                카드사 취소 처리는 영업일 기준으로 3~5일까지 소요될 수 있습니다.
              </p>
            </div> */
